import * as React from 'react';
import {Component} from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import {
    Avatar,
    Button, ClickAwayListener, CssBaseline,
    Dialog,
    DialogActions,
    DialogTitle,
    IconButton,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Modal,
    Popover,
    Stack, ThemeProvider,
    Tooltip
} from "@mui/material";
import {connect} from "react-redux";
import {
    changeCaseShareModalOpenState,
    changeLinkExpiration, changeSlideShareModalOpenState, removeLinkExpiration
} from "../../redux_actions/shareManager.action";
import MultipleSelectChip from "./multiselectChip";
import {
    assignCaseToGroups,
    generateAnonymousShareLink,
    getGroupsForSharing,
    getListOfAccessForSharing,
    getListOfAccessForSharingCase, removeUserAccessToCase,
    revokeShareAccessSlide,
    shareSlideToGroups
} from "../../utils/api";
import {message} from "antd";
import {copyToClipboard, isNull, isTrue, notNull, stringForAvatar} from "../../utils/utils";
import GroupRemoveIcon from '@mui/icons-material/GroupRemove';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import GroupDetailPopover from "./groupDetailPopover";
import {updateUrlStateInReducer} from "../../redux_actions/search.action";
import PickerWithButtonField from "./ButtonDateTimePicker";
import {store} from "../../helper/store";
import {openInNewTabType} from "../../utils/const";
import {getCase} from "../../redux_actions/cases.action";
import {defaultTheme} from "../gammaviewer/themes";
import PersonIcon from "@mui/icons-material/Person";
import DoDisturbOffIcon from '@mui/icons-material/DoDisturbOff';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: 2,
};

class ShareModal extends Component {

    constructor(props) {
        super(props);
        this.state = this.initState();
    }

    initState = () => {

        this.groupPopoverDetails = null;
        this.allowModalClose = false;

        let linkExpiry = new Date();
        linkExpiry.setDate(linkExpiry.getDate() + 30);
        linkExpiry.setHours(23, 59, 59, 999);
        this.props.dispatch(changeLinkExpiration(linkExpiry));

        this.isSingleSlide = this.props.type === openInNewTabType.SLIDE && this.props.slidelist.length === 1;
        this.isSingleCase = this.props.type === openInNewTabType.CASE && this.props.caselist.length === 1;
        this.isMultipleSlide = this.props.type === openInNewTabType.SLIDE && this.props.slidelist.length > 1;
        this.isMultipleCase = this.props.type === openInNewTabType.CASE && this.props.caselist.length > 1;

        return {
            groups: null,
            selectedGroups: [],
            confirmDialogOpen: false,
            peopleWithAccess: [],
            ownerDetails: null,
            anchorElRevoke: null,
            groupDetailPanelActive: false,
            tooltipOpen: false,
            preventModalClose: false,
        }
    }

    confirmAndClose = (event, reason) => {
        if (reason && reason === 'backdropClick') {
            // Check if any input is filled, if yes then show a confirmation dialog
            if (this.state.preventModalClose || this.state.selectedGroups.length > 0) {
                this.setState({
                    confirmDialogOpen: true
                })
            } else {
                this.handleClose();
            }
        } else {
            this.handleClose()
        }
    }

    handleClose = () => {
        if (this.props.type === openInNewTabType.CASE) {
            if(notNull(this.props.caseRefreshProps) && this.props.caseRefreshProps.length > 0) {
                this.props.caseRefreshProps.map((caseInfo) => {
                    this.props.dispatch(getCase(caseInfo.id, caseInfo, [], !isTrue(this.props.getFullCaseData)));
                })
            }
            this.props.dispatch(changeCaseShareModalOpenState())
        } else if (this.props.type === openInNewTabType.SLIDE) {
            this.props.dispatch(changeSlideShareModalOpenState())
        }
    }

    prepareForGroupDetailPopover = (event, detail) => {
        if (isTrue(detail?.is_group)) {
            detail["clientX"] = event.clientX;
            detail["clientY"] = event.clientY;
            this.groupPopoverDetails = detail;
            this.setState({groupDetailPanelActive: true})
        } else {
            this.setState({groupDetailPanelActive: false})
        }
    }

    peopleWithAccessList = () => {

        let person_list;
        person_list = (this.isSingleSlide || this.isSingleCase) && this.state.peopleWithAccess && this.state.peopleWithAccess.map((person) => {
            const iconToShow = isTrue(person.is_group) ? <GroupRemoveIcon/> : <PersonRemoveIcon/>;
            return <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                <ListItem sx={{width: '80%', p: 0}}>
                    <ListItemAvatar>
                        <Avatar {...stringForAvatar(person.display_name, person.is_group)} />
                    </ListItemAvatar>
                    <ListItemText primary={person.display_name}
                                  secondary={isTrue(person.is_group) ? "Group" : person.name}
                                  primaryTypographyProps={{fontWeight: "medium"}}
                                  sx={{flex: 'none'}}
                                  onMouseEnter={(event) => this.prepareForGroupDetailPopover(event, person)}
                                  onMouseLeave={() => {
                                      this.setState({groupDetailPanelActive: false})
                                  }}/>
                </ListItem>
                {person['shared_through_case'] ?
                    <Tooltip title="Shared via Case" placement={"left"}>
                        <span style={{marginRight: 5}}>
                            <IconButton aria-label="remove-person" disabled={true}><DoDisturbOffIcon/></IconButton>
                        </span>
                    </Tooltip> :
                    <Tooltip title="Revoke Access" placement={"left"}>
                        <IconButton aria-label="remove-person"
                                    onClick={e => {
                                        this.revokeName = person.name;
                                        this.setState({anchorElRevoke: e.currentTarget})
                                    }}
                                    sx={{width: "10%", "&:hover": {color: "#C04000"}}}>{iconToShow}</IconButton>
                    </Tooltip>}
            </Stack>
        })

        let owner_detail = (this.isSingleSlide || this.isSingleCase) ?
            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                <ListItem sx={{width: '80%', p: 0}}>
                    <ListItemAvatar>
                        <Avatar sx={{bgcolor: "purple"}}> {isTrue(this.state.ownerDetails?.is_group) ? <PeopleAltIcon/> : <PersonIcon/>} </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={this.state.ownerDetails?.display_name || "Loading"} secondary={isTrue(this.state.ownerDetails?.is_group)? "Group" : "User"}
                                  primaryTypographyProps={{fontWeight: "medium"}}
                                  sx={{flex: 'none'}}
                                  onMouseEnter={(event) => this.prepareForGroupDetailPopover(event, this.state.ownerDetails)}
                                  onMouseLeave={() => {
                                      this.setState({groupDetailPanelActive: false})
                                  }}/>
                </ListItem>
                <Typography sx={{p: 0, fontWeight: "medium"}}>
                    Owner
                </Typography>
            </Stack> : null;

        let multipleSelectionText = "";

        if (this.isMultipleSlide) {
            multipleSelectionText = "You are sharing multiple slides, select a single slide to see the people and groups with access.";
        } else if (this.isMultipleCase) {
            if (isTrue(this.props.assign)) {
                multipleSelectionText = "You are assigning multiple cases, select a single case to see the people and groups assigned for case.";
            } else {
                multipleSelectionText = "You are sharing multiple cases, select a single case to see the people and groups with access.";
            }
        }

        return <Stack direction={"column"} sx={{py: 1.5}}>
            <Typography id="transition-modal-description" variant="body1" component="body1"
                        sx={{pb: 1, fontWeight: "bold"}}>
                {isTrue(this.props.assign) ? "Assigned People and Groups" : "People and Groups with access"}
            </Typography>

            {(this.isMultipleSlide || this.isMultipleCase) ? <Typography variant="body2" component="body2">
                    {multipleSelectionText}
                </Typography> :
                <Stack direction={"column"} className={'scrollbar'} sx={{maxHeight: '280px', height: 'auto'}}>
                    {owner_detail}
                    {person_list}
                </Stack>}
        </Stack>
    }

    handleTooltip = (isOpen) => {
        this.setState({tooltipOpen: isOpen});
    }

    headingComponent = () => {

        let heading = "Share";
        if (isTrue(this.props.assign)) {
            heading = "Assign";
        }

        if (this.props.type === openInNewTabType.CASE) {
            if (this.props.caselist.length === 1) {
                const case_name = notNull(this.props.case_id) ? this.props.case_id : this.props.allCases[this.props.caselist[0]]?.case_id;
                heading += " " + case_name;
            } else {
                heading += " " + this.props.caselist.length + " Cases";
            }
        } else if (this.props.type === openInNewTabType.SLIDE) {
            if (this.props.slidelist.length === 1) {
                this.props.allSlides.hasOwnProperty(this.props.slidelist[0]) && (heading += " " + this.props.allSlides[this.props.slidelist[0]].name);
            } else {
                heading += " " + this.props.slidelist.length + " Slides";
            }
        }

        return <Stack direction={"row"} alignContent={"center"} justifyContent={"space-between"}>
            <Typography id="transition-modal-title" variant="h5" component="h5" sx={{width: '90%'}}>
                {heading}
            </Typography>
            <ClickAwayListener onClickAway={() => this.state.tooltipOpen && this.handleTooltip(false)}>
                <Tooltip
                    onClose={() => this.handleTooltip(false)}
                    open={this.state.tooltipOpen}
                    placement={'top'}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    PopperProps={{
                        disablePortal: true,
                    }}
                    arrow
                    title={"Share slides with groups and people. You can also revoke access from here. Create public link to share with anyone."}
                >
                    <IconButton sx={{width: '8%'}}
                                onClick={() => this.handleTooltip(true)}><HelpOutlineIcon/></IconButton>
                </Tooltip>
            </ClickAwayListener>
        </Stack>
    }

    confirmShare = () => {
        const groups = this.state.selectedGroups;
        const slideList = this.props.slidelist;
        const caseList = this.props.caselist;

        if (groups.length !== 0) {
            if (this.props.type === openInNewTabType.CASE) {
                assignCaseToGroups(caseList, groups, !isTrue(this.props.assign)).then(res => {
                    if (res.status !== 200) {
                        message.error("Some error occurred while sharing case");
                        this.handleClose();
                        return;
                    }
                    this.handleClose();
                    if (isTrue(this.props.assign)) {
                        message.success("Case(s) assigned successfully");
                    } else {
                        message.success("Case(s) shared successfully");
                    }
                }).catch(() => {
                    this.handleClose();
                    message.error("Some error occurred while sharing cases");
                })
            } else if (this.props.type === openInNewTabType.SLIDE) {
                shareSlideToGroups(slideList, groups).then(res => {
                    if (res.status !== 200) {
                        message.error("Some error occurred while sharing slide");
                        this.handleClose();
                        return;
                    }
                    this.handleClose();
                    message.success("Slide(s) shared successfully");
                }).catch(() => {
                    this.handleClose();
                    message.error("Some error occurred while sharing slide");
                })
            }
        } else if (isTrue(this.allowModalClose)) {
            this.handleClose();
        } else {
            message.error("Please select atleast one group");
        }
    }

    generateLink = () => {
        const slideList = this.props.slidelist;
        generateAnonymousShareLink(slideList, this.props.link_expiration).then(res => {
            if (res.status !== 200) {
                message.error("Some error occurred while generating link");
                this.handleClose();
                return;
            }
            this.handleClose();
            copyToClipboard(res.data["token"]);
            message.success("Link copied to clipboard. Share it with anyone.");
        }).catch(() => {
            this.handleClose();
            message.error("Some error occurred while generating link");
        })
    }

    getInitialData = () => {
        if (this.isSingleSlide) {
            // Fetch all people/group with access to the slide (only if single slide is selected)
            getListOfAccessForSharing(this.props.slidelist[0]).then(res => {
                if (res.status !== 200) {
                    message.error("Error in fetching Access List");
                    this.setState({
                        peopleWithAccess: [],
                        ownerDetails: []
                    })
                    return;
                }
                this.setState({
                    peopleWithAccess: res.data.shared_list,
                    ownerDetails: res.data.owner[0] ? res.data.owner[0] : []
                })
            }).catch(err => console.log(err))
        } else if (this.isSingleCase) {
            // Fetch all people/group with access to the case (only if single case is selected)
            getListOfAccessForSharingCase(this.props.caselist[0], isTrue(this.props.assign)).then(res => {
                if (res.status !== 200) {
                    message.error("Error in fetching Access List");
                    this.setState({
                        peopleWithAccess: [],
                        ownerDetails: []
                    })
                    return;
                }
                this.setState({
                    peopleWithAccess: res.data.shared_list,
                    ownerDetails: res.data.owner[0] ? res.data.owner[0] : []
                })
            }).catch(err => console.log(err))
        }
    }

    handleAccessRevoke = () => {
        this.setState({anchorElRevoke: null})

        if (this.isSingleSlide) {
            revokeShareAccessSlide(this.props.slidelist[0], this.revokeName).then(res => {
                this.allowModalClose = true;
                if (isTrue(res.data["access_revoked"])) {
                    this.handleClose();
                    this.props.dispatch(updateUrlStateInReducer(this.props.urlStateDashboard))
                } else {
                    this.getInitialData();
                }
            })
        } else if (this.isSingleCase) {
            removeUserAccessToCase(this.props.caselist[0], this.revokeName, isTrue(this.props.assign)).then(res => {
                this.allowModalClose = true;
                if (isTrue(res.data["access_revoked"])) {
                    this.handleClose();
                } else {
                    this.getInitialData();
                }
            })
        }


    }

    componentDidMount() {
        //Fetch all groups belonging to the organisation of user
        getGroupsForSharing().then(res => {
            if (res.status !== 200) {
                message.error("Error in fetching groups ");
                return;
            }
            this.setState({groups: res.data})
        }).catch(err => {
            this.setState({groups: []})
            console.log(err)
        })

        this.getInitialData()
    }

    getConfirmDialogComponent = () => {
        return (<Dialog
            sx={{'& .MuiDialog-paper': {width: '80%', maxHeight: 435}}}
            maxWidth="xs"
            open={this.state.confirmDialogOpen}
        >
            <DialogTitle>Discard unsaved changes?</DialogTitle>
            <DialogActions>
                <Button autoFocus style={{textTransform: "none", color: "gray"}}
                        onClick={() => this.setState({confirmDialogOpen: false})}>
                    Cancel
                </Button>
                <Button style={{textTransform: "none"}} onClick={this.handleClose}>Discard</Button>
            </DialogActions>
        </Dialog>)
    }

    getConfirmRevokeDialogComponent = () => {
        return <Popover open={this.state.anchorElRevoke} anchorEl={this.state.anchorElRevoke}
                        onClose={() => this.setState({anchorElRevoke: null})}
                        anchorOrigin={{
                            vertical: 'bottom', horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top', horizontal: 'right',
                        }}>
            <Stack direction={"column"} justifyContent={"center"} alignItems={"center"} sx={{p: 1}}>
                <Typography>Remove Access?</Typography>
                <Stack direction={"row"} justifyContent={"center"} alignItems={"center"}>
                    <Button sx={{textTransform: "none"}} onClick={this.handleAccessRevoke}>Yes</Button>
                    <Button sx={{textTransform: "none", color: "rgba(231,13,20,0.78)"}}
                            onClick={() => this.setState({anchorElRevoke: null})}>No</Button>
                </Stack>
            </Stack>
        </Popover>
    }

    getGroupDetailPopover = () => {
        return <Popover
            sx={{pointerEvents: 'none'}}
            open={this.state.groupDetailPanelActive}
            anchorReference="anchorPosition"
            anchorPosition={{top: this.groupPopoverDetails?.clientY || 0, left: this.groupPopoverDetails?.clientX || 0}}
            transformOrigin={{
                vertical: 'top', horizontal: 'left',
            }}
        >
            <GroupDetailPopover data={this.groupPopoverDetails}/>
        </Popover>
    }

    anonymousLinkComponent = () => {

        return <Stack direction={"column"} justifyContent={"space-between"} sx={{mt: 2}} spacing={1}>
            <Typography variant="body1" component="body1" sx={{pb: 1, fontWeight: "bold"}}>General Access
                Link</Typography>
            <Stack direction={"row"} spacing={1} alignItems={'center'}>
                <TimerOutlinedIcon/>
                <Typography>
                    Access
                    expires {isNull(this.props.link_expiration) ? ' Never' : ` ${this.props.link_expiration.toLocaleString('en-US', {
                    hour12: true, dateStyle: 'medium', timeStyle: 'short'
                })}`}
                </Typography>
                <Tooltip title={"Edit expiration"} placement={"bottom"}><PickerWithButtonField
                    defaultValue={this.props.link_expiration}
                    onAccept={(newValue) => {
                        store.dispatch(changeLinkExpiration(new Date(newValue)));
                        this.setState({preventModalClose: true});
                    }}/></Tooltip>
                {notNull(this.props.link_expiration) ?
                    <Tooltip title={"Remove expiration"} placement={"bottom"}><IconButton
                        onClick={() => this.props.dispatch(removeLinkExpiration())}><DeleteOutlineOutlinedIcon/></IconButton></Tooltip> : null}
            </Stack>
        </Stack>
    }

    render() {
        const open = this.props.slideModalOpen || this.props.caseModalOpen;

        return (<ThemeProvider theme={defaultTheme}>
            <CssBaseline/>
            {this.getConfirmDialogComponent()}
            {this.getConfirmRevokeDialogComponent()}
            {this.getGroupDetailPopover()}
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={this.confirmAndClose}
                closeAfterTransition
                slots={{backdrop: Backdrop}}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <Stack direction={"column"} sx={{minHeight: 500}}>
                            {this.headingComponent()}

                            <MultipleSelectChip options={this.state.groups} selectedOptions={this.state.selectedGroups}
                                                updateSelectedOptions={(selectedOptions) => {
                                                    this.setState({selectedGroups: selectedOptions})
                                                }}/>

                            {this.peopleWithAccessList()}

                            {!isTrue(this.props.assign) && this.anonymousLinkComponent()}

                            <Stack direction={"row"} justifyContent={"space-between"} mt={'auto'}>
                                {isTrue(this.props.assign) ? <div></div> : <Button variant="outlined" disableElevation onClick={this.generateLink} style={{
                                    textTransform: 'none', borderRadius: '5px'
                                }} color="primary">Generate Link</Button>}
                                <Button variant="contained" disableElevation onClick={this.confirmShare} sx={{
                                    textTransform: 'none', borderRadius: '5px'
                                }} color="primary">Done</Button>
                            </Stack>

                        </Stack>
                    </Box>
                </Fade>
            </Modal></ThemeProvider>)
    }
}

const mapStateToProps = state => {
    let {slideModalOpen, caseModalOpen, slidelist, caselist, link_expiration} = state.shareManagerReducer;
    let allSlides = state.slidesReducer;
    let allCases = state.casesReducer;
    let urlStateDashboard = state.searchReducer;
    return {
        slideModalOpen,
        caseModalOpen,
        slidelist,
        caselist,
        link_expiration,
        allSlides,
        allCases,
        urlStateDashboard
    };
};

export default connect(mapStateToProps)(ShareModal);